/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createEfimovFactor } from '../../factoriesAny.js';
export var efimovFactorDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createEfimovFactor: createEfimovFactor
};